import { IUserFeedbackMessagePayload } from '@src/service/business/common/types';
import UserFeedbackBusinessStore from '@src/service/business/common/userFeedbackBusinessProvider';
import StoreService from '@src/service/business/StoreService';

export class UserHelperUtils {
  static reportMessage = (value: IUserFeedbackMessagePayload) => {
    return StoreService.dispatchAction(UserFeedbackBusinessStore.actions.reportMessage(value));
  };
}
